import analytics from '../analytics/analytics';
import {formTrackingDataLayer, formTrackingPageDataLayer} from '../form-tracking/form-tracking-analytics';
import attrIsTruthy from '../../../../Common/js/util/attributeHelper';
import calculateDistance from '../../../../Common/js/util/distanceCalculator';
import isFormValid from './isFormValid';
import { GoogleMapsLocation } from '../../../../Common/modules/google-maps/google-maps-places';

const membershipObject = {
  subBranchFinder(keyword){
    if ($('.membership-header .form-textfield .autocomplete')) {
      $('.membership-header .form-textfield .autocomplete').remove();
    }

    //Make google maps request based on keyword
    //Do sort based on lat/long distance on jsSearchIndex
    if (keyword.length > 1) {
      $('.membership-body').addClass('inactive');

      var locationSearcher = new GoogleMapsLocation();
      locationSearcher.SearchForLocation(keyword, membershipObject.displaySuggestions);
    }
  },

  displaySuggestions(predictions, status) {
    if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) {
      console.log("google.maps.places not ready...");
      return;
    }

    if (predictions.length > 1) {
      predictions.sort(function (a, b) {
        return b.description.includes("QLD") ? 1 : a.description.includes("QLD") ? -1 : 0;
      })
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: predictions[0].place_id }, (results, status) => {
      var html = "<ul class='autocomplete'>";
      if (status !== "OK" || !results || !results[0]) {
        console.log("Geocoder failed due to: " + status);
        return { prediction: predictions[0], results: null };
      }
      var nearestSubBranches = membershipObject.matchPredictionToNearestSubbranch(results[0], 4);
      if (nearestSubBranches != null) {
        nearestSubBranches.forEach((subBranch) => {
          //display subbranch
          html += "<li class='autocomplete-item'><button class='autocomplete-button' data-branch-id='" + subBranch.id + "'" +
            "data-btn-ga-enabled='True' data-ga-config='eventName=trackForm&amp;buttonGroup=FormBranchFinder&amp;" +
            "buttonCallToAction=trackForm&amp;buttonDescription=FormBranchFinder&amp;buttonPlacement=Membership Form&amp;" +
            "buttonDestination=/&amp;action='" +
            "data-ga-form-action-info='formId=Membership Form&amp;step=0&amp;nextStep=1&amp;formCompleted=False'" +
            ">" + subBranch.title + "</button></li>";
        });

        html += "</ul>";
        $('.membership-header .form-textfield').append(html);
        Promise.resolve();
      }
    });
  },

  matchPredictionToNearestSubbranch(result, amount = 3){
    var sortedSubBranches = [];
    if (!window.jsonSearchIndex.SubBranchDirectory || !window.jsonSearchIndex) {
      return null;
    }

    window.jsonSearchIndex.SubBranchDirectory.forEach((e) => {
      if (!e || !e.Location) {
        return null;
      }

      var lat1 = result.geometry.location.lat();
      var lng1 = result.geometry.location.lng();
      var lat2 = parseFloat(e.Location.split(",")[0]);
      var lng2 = parseFloat(e.Location.split(",")[1]);
      var distance = calculateDistance(lat1, lng1, lat2, lng2);
      sortedSubBranches.push({ id: e.BranchID, title: e.Title, distance: distance });
    });

    return sortedSubBranches.sort((el1, el2) => { return el1.distance - el2.distance }).slice(0, amount);
  }

}

$(() => {
    if ($(".membership").length) {
      $('.red-secondary-text label.membership-label.membership-secondary-text').each(function () {
        $(this).addClass('red-color')
      });
      var rslqld_sitecore_membership_form = $('.rslqld-membership-form-fields');
      var privacyTabFormIds = ['1114c364-458d-45d1-adbb-b031f468b502', '52fff1d7-53dd-443c-bb81-2d1fd64fa65a']
      var formId = $('#formId').val();
      if (rslqld_sitecore_membership_form.length === 0) {
        if (window.innerWidth <= 768) {
          if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
            $(".membership-tabs__tab:nth-child(3),.membership-tabs__tab:nth-child(4),.membership-slides-nav__dot:nth-child(3),.membership-slides-nav__dot:nth-child(4)").addClass('inactive');
          } else {
            $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3),.membership-slides-nav__dot:nth-child(2),.membership-slides-nav__dot:nth-child(3)").addClass('inactive');

            if ($('#subbranch').length) {
              $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").addClass('active');
              $(".membership-slides-slide .change-step").hide();
              $(".membership-slides-slide:nth-child(4) .form-bottom .btn--yellow.change-step").show();
            } else {
              $(".membership-slides-slide:nth-child(2),.membership-slides-slide:nth-child(3)").addClass('active');
              $(".membership-slides-slide .change-step").hide();
              $(".membership-slides-slide:nth-child(3) .form-bottom .btn--yellow.change-step").show();
            }
          }
        } else {
          if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
            AddTabsExtraRow();
          }
        }
      }

      function AddTabsExtraRow() {
        if ($('.membership-tabs-extra-row').length === 0) {
          var membershipTabs = $('.membership-tabs');
          var divRow1 = $('<div>').addClass('membership-tabs').addClass('membership-tabs-extra-row')
          var divRow2 = $('<div>').addClass('membership-tabs').addClass('membership-tabs-row')
          $(".membership-tabs__tab").each(function (index) {
            if (index === 0) {
              $(this).addClass('membership-tabs__tab-extra-row')
              divRow1.append(this)
            } else {
              divRow2.append(this)
            }
          })
          membershipTabs.append(divRow1, divRow2)
          membershipTabs.removeClass('membership-tabs')
        }
      }

      function RemoveTabsExtraRow() {
        if ($('.membership-tabs-extra-row').length > 0) {
          var membershipTabs = $('.membership-tabs-extra-row').parent();
          $(".membership-tabs__tab").each(function (index) {
            $(this).removeClass('membership-tabs__tab-extra-row').removeClass('membership-tabs-row')
            membershipTabs.append(this);
          })
          $('.membership-tabs-row').remove();
          $('.membership-tabs-extra-row').remove();
          membershipTabs.addClass('membership-tabs')
        }
      }

        $('#subbranch').smartkeyup(() => {
          $.when(membershipObject.subBranchFinder($('#subbranch').val()))
        });

        $('.js-form-select').parent().css("z-index", "2");

        $(document).on('click touchend', '.membership-header .form-textfield .autocomplete button', function (e) {
            e.preventDefault();
            $('#subbranch').val(this.textContent);
            $('#branchId').val(this.getAttribute('data-branch-id')).trigger('change');
            $('.membership-header .form-textfield .autocomplete').remove();
            $('.membership-body').removeClass('inactive');
            const $btnEl = $(this);
            if ($btnEl.length && attrIsTruthy($btnEl.data('btn-ga-enabled')) && $btnEl.data('ga-config')) {
                analytics.trackDataLayerBtnEvent($btnEl);
            }
            switchStep(0, true);
        });

        $('#subbranch').on('focusout', function (e) {
            setTimeout(function () {
                $('.membership-header .form-textfield .autocomplete').remove();
            }, 200);
        });

        $(".membership-checkbox > .membership-checkbox-item > input[type=checkbox][data-copy-container]").on('change', function () {
            var self = $(this).closest('fieldset').find('input[type=text]');
            var copyName = $(this).data('copyContainer');

            if (this.checked && copyName) {
                var copy = $(this).closest('.membership-slides-slide').find('#' + copyName).find('input[type=text]');
                for (var i = 0; i < $(copy).length; i++) {
                    $(self)[i].value = $(copy)[i].value;
                    if ($(self)[i].value) {
                        $(self[i]).parent().removeClass('empty');
                    } else {
                        $(self[i]).parent().addClass('empty');
                    }
                }
            } else {
                for (var i = 0; i < $(self).length; i++) {
                    $(self)[i].value = "";
                    $(self[i]).parent().addClass('empty');
                }
            }
        });

        $(".membership-radio > .membership-radio-item > input[type=radio]").on('change', function () {
            var visibiltyChanged = false;

            if ($(this).data("show-visibility-group")) {
                $("." + $(this).data("show-visibility-group")).show();
                visibiltyChanged = true;
            }

            if ($(this).data("hide-visibility-group")) {
                $("." + $(this).data("hide-visibility-group")).hide();
                visibiltyChanged = true;
            }
        });

        $(".membership-checkbox > .membership-checkbox-item > input[type=checkbox]").on('change', function () {
            var visibiltyChanged = false;

            if ($(this).prop("checked") == true) {
                if ($(this).data("show-visibility-group")) {
                    $("." + $(this).data("show-visibility-group")).show();
                    visibiltyChanged = true;
                }

                if ($(this).data("hide-visibility-group")) {
                    $("." + $(this).data("hide-visibility-group")).hide();
                    visibiltyChanged = true;
                }
            }

            if ($(this).prop("checked") == false) {
                if ($(this).data("show-visibility-group")) {
                    $("." + $(this).data("show-visibility-group")).hide();
                    visibiltyChanged = true;
                }

                if ($(this).data("hide-visibility-group")) {
                    $("." + $(this).data("hide-visibility-group")).show();
                    visibiltyChanged = true;
                }
            }
        });

        $(".js-form-select select").on('change', function () {
            var selectedValue = $(this).children("option:selected").val();
            var Element = $(this).closest(".js-form-select").children(".form-select-choice-attributes").children("div[data-choice-value='" + selectedValue + "']");

            var visibiltyChanged = false;

            if ($(Element).data("show-visibility-group")) {
                $("." + $(Element).data("show-visibility-group")).show();
                visibiltyChanged = true;
            }

            if ($(Element).data("hide-visibility-group")) {
                $("." + $(Element).data("hide-visibility-group")).hide();
                visibiltyChanged = true;
            }
        });

        

        



        $(".membership-tabs__tab").on("click", function () {
            var index = parseInt($(this).find('.membership-tabs__tab--number')[0].innerText.replace('.', '')) - 1;
            switchStep(index);
        });

        async function switchStep(index, dontValidate = false) {
            if (dontValidate === true || await isFormValid()) {
                $(".membership-tabs__tab, .membership-slides-nav__dot").removeClass('active');
                $(".membership-slides-slide").each(function (i) {
                    if (i < index) {
                        $(this).removeClass('active').addClass('done');
                        $($(".membership-tabs__tab")[i]).addClass('done');
                    } else if (i == index) {
                        $(this).addClass('active').removeClass('done');
                        $($(".membership-tabs__tab")[i]).addClass('active');
                        $($(".membership-slides-nav__dot")[i]).addClass('active');
                    } else if (i > index) {
                        $(this).removeClass('active').removeClass('done');
                        $($(".membership-tabs__tab")[i]).removeClass('done');
                    }
                });
                if (window.innerWidth <= 768 && rslqld_sitecore_membership_form.length === 0) {
                  if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
                    $(".membership-tabs__tab:nth-child(3),.membership-tabs__tab:nth-child(4),.membership-slides-nav__dot:nth-child(3),.membership-slides-nav__dot:nth-child(4)").addClass('inactive');
                    var firstThreeSlidesSelector = ".membership-slides-slide:nth-child(2),.membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)";
                    if ($('#subbranch').length) {
                      firstThreeSlidesSelector = ".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4),.membership-slides-slide:nth-child(5)";
                    }
                    if (index < 4 && index > 0) {
                      $(firstThreeSlidesSelector).addClass('active').removeClass('done');
                      $(".membership-slides-slide .change-step").hide();
                      if ($('#subbranch').length) {
                        $(".membership-slides-slide:nth-child(5) .form-bottom .btn--yellow.change-step").show();
                      } else {
                        $(".membership-slides-slide:nth-child(4) .form-bottom .btn--yellow.change-step").show();
                      }
                    } else {
                      $(firstThreeSlidesSelector).removeClass('active').addClass('done');
                      $(".membership-slides-slide  .change-step").show();
                    }
                  } else {
                    $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3),.membership-slides-nav__dot:nth-child(2),.membership-slides-nav__dot:nth-child(3)").addClass('inactive');
                    var firstThreeSlidesSelector = ".membership-slides-slide:nth-child(1),.membership-slides-slide:nth-child(2),.membership-slides-slide:nth-child(3)";
                    if ($('#subbranch').length) {
                        firstThreeSlidesSelector = ".membership-slides-slide:nth-child(2),.membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)";
                    }
                    if (index < 3) {
                        $(firstThreeSlidesSelector).addClass('active').removeClass('done');
                        $(".membership-slides-slide .change-step").hide();
                        if ($('#subbranch').length) {
                            $(".membership-slides-slide:nth-child(4) .form-bottom .btn--yellow.change-step").show();
                        } else {
                            $(".membership-slides-slide:nth-child(3) .form-bottom .btn--yellow.change-step").show();
                        }
                    } else {
                        $(firstThreeSlidesSelector).removeClass('active').addClass('done');
                        $(".membership-slides-slide  .change-step").show();
                    }
                  }
                }
              if ($(".membership-body").length !== 0) $('html,body').animate({ scrollTop: $(".membership-body").offset().top - 140 }, 1000);
            }
        }

        $('.membership-file input[type=file]').on("change", function () {
            var filename = $(this)[0].value.split("\\");
            $(this).next()[0].innerText = filename[filename.length - 1];
        });

        $('.change-step').on("click", function () {
          if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
            if ($(this).data('step') == 6) {
              $('.membership-tabs__tab:nth-child(6), .membership-slides-nav__dot:nth-child(6)').removeClass('inactive');
            }
            var step = $(this).data('step') - 1;
            if (window.innerWidth <= 768 && step < 4 && step > 0) {
              step = 1;
            }
            formTrackingPageDataLayer(step, window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1));
            switchStep(step);
          } else {
            if ($(this).data('step') == 5) {
                $('.membership-tabs__tab:nth-child(5), .membership-slides-nav__dot:nth-child(5)').removeClass('inactive');
            }
            var step = $(this).data('step') - 1;
            if (window.innerWidth <= 768 && step < 3) {
                step = 0;
            }
            formTrackingPageDataLayer(step, window.location.pathname.substr(window.location.pathname.lastIndexOf('/')+1));
            switchStep(step);
          }
        })

      $(window).resize(function () {
        if (rslqld_sitecore_membership_form.length === 0) {
             RemoveTabsExtraRow();
            if ($('#subbranch').length) {
                if (window.innerWidth <= 768) {
                  if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
                    $(".membership-tabs__tab:nth-child(3),.membership-tabs__tab:nth-child(4),.membership-slides-nav__dot:nth-child(3),.membership-slides-nav__dot:nth-child(4)").addClass('inactive');
                    if ($(".membership-slides-slide:nth-child(3)").hasClass('active')) {
                      $(".membership-slides-slide:nth-child(4),.membership-slides-slide:nth-child(5)").addClass('active');
                      $(".membership-slides-slide .change-step").hide();
                      $(".membership-slides-slide:nth-child(5) .form-bottom .btn--yellow.change-step").show();
                    }
                  } else {
                    $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3),.membership-slides-nav__dot:nth-child(2),.membership-slides-nav__dot:nth-child(3)").addClass('inactive');
                    if ($(".membership-slides-slide:nth-child(2)").hasClass('active')) {
                        $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").addClass('active');
                        $(".membership-slides-slide .change-step").hide();
                        $(".membership-slides-slide:nth-child(4) .form-bottom .btn--yellow.change-step").show();
                    }
                  }
                } else {
                  if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
                    AddTabsExtraRow();
                    $(".membership-tabs__tab:nth-child(3),.membership-tabs__tab:nth-child(4),.membership-slides-nav__dot:nth-child(3),.membership-slides-nav__dot:nth-child(4)").removeClass('inactive');
                    if ($(".membership-slides-slide:nth-child(3)").hasClass('active')) {
                      $(".membership-slides-slide .change-step").show();
                      $(".membership-slides-slide:nth-child(4),.membership-slides-slide:nth-child(5)").removeClass('active');
                    }
                  } else {
                    $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3),.membership-slides-nav__dot:nth-child(2),.membership-slides-nav__dot:nth-child(3)").removeClass('inactive');
                    if ($(".membership-slides-slide:nth-child(2)").hasClass('active')) {
                        $(".membership-slides-slide .change-step").show();
                        $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").removeClass('active');
                    }
                  }
                }
            } else {
                if (window.innerWidth <= 768) {
                  if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
                    $(".membership-tabs__tab:nth-child(3),.membership-tabs__tab:nth-child(4),.membership-slides-nav__dot:nth-child(3),.membership-slides-nav__dot:nth-child(4)").addClass('inactive');
                    if ($(".membership-slides-slide:nth-child(2)").hasClass('active')) {
                      $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").addClass('active');
                      $(".membership-slides-slide .change-step").hide();
                      $(".membership-slides-slide:nth-child(4) .form-bottom .btn--yellow.change-step").show();
                    }
                  } else {
                    $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3),.membership-slides-nav__dot:nth-child(2),.membership-slides-nav__dot:nth-child(3)").addClass('inactive');
                    if ($(".membership-slides-slide:nth-child(1)").hasClass('active')) {
                        $(".membership-slides-slide:nth-child(2),.membership-slides-slide:nth-child(3)").addClass('active');
                        $(".membership-slides-slide .change-step").hide();
                        $(".membership-slides-slide:nth-child(3) .form-bottom .btn--yellow.change-step").show();
                    }
                  }
                } else {
                  if (formId != null && $.inArray(formId.toLowerCase(), privacyTabFormIds) !== -1) {
                    AddTabsExtraRow();
                    $(".membership-tabs__tab:nth-child(3),.membership-tabs__tab:nth-child(4),.membership-slides-nav__dot:nth-child(3),.membership-slides-nav__dot:nth-child(4)").removeClass('inactive');
                    if ($(".membership-slides-slide:nth-child(2)").hasClass('active')) {
                      $(".membership-slides-slide .change-step").show();
                      $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").removeClass('active');
                    }
                  } else {
                    $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3),.membership-slides-nav__dot:nth-child(2),.membership-slides-nav__dot:nth-child(3)").removeClass('inactive');
                    if ($(".membership-slides-slide:nth-child(1)").hasClass('active')) {
                      $(".membership-slides-slide .change-step").show();
                      $(".membership-slides-slide:nth-child(2),.membership-slides-slide:nth-child(3)").removeClass('active');
                    }
                  }
                }
            }
          }
        });

        function objectifyForm(formId, formHeader, formArray, formFiles) {
            let i; // serialize data function

            const returnArray = {};

            for (i = 0; i < formHeader.length; i++) {
                returnArray[formHeader[i].name] = formHeader[i].value;
            }

            for (i = 0; i < formArray.length; i++) {
                // If we have multiple values under the same field name (ie. checkbox) it will only take the last value.
                if (returnArray[formArray[i].name] == undefined) { // If no value, add a new one
                    returnArray[formArray[i].name] = formArray[i].value;
                } else { // If value exists, append with comma delimited list
                    var oldValue = returnArray[formArray[i].name];
                    var newValue = ', ' + formArray[i].value;
                    returnArray[formArray[i].name] = oldValue + newValue;
                }
            }

            const formData = new FormData();
            formData.append("FormId", formId);
            formData.append("FormData", JSON.stringify(returnArray));

            for (i = 0; i < formFiles.length; i++) {
                formData.append("FileUpload_" + i, formFiles[i].files[0]);
            }

            return formData;
        }

        $('.membership-body button[type=submit]').on("click", async function () {
            if (await isFormValid()) {
                const formHeader = $(this).closest('.membership').children('.membership-header');
                const formContainer = $(this).closest('.membership-slides');
                const formId = $(this).closest('.membership').find('#formId').val();
                const formFiles = formContainer.find("input[type=file]");
                const formData = objectifyForm(formId, formHeader.find("input").serializeArray(), formContainer.find("input,select,textarea").serializeArray(), formFiles),
                    $formLoading = $('.membership-loading'),
                    $formLoader = $formLoading.find('.form-loader');

                $(".membership-body, .membership-header").addClass('inactive');

                $formLoader.addClass('active');
                $formLoading.removeClass('inactive');

                // Ajax request
                $.ajax({
                    url: $('.membership-body').data('postAction'),
                    method: 'POST',
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    data: formData,
                    success: function (result) {
                        if (result === '') {
                            $(".membership-thankyou[data-response-type=false]").removeClass('inactive');
                            return;
                        }
                        if (result) {
                            if (result.Status === "Success") {
                                if (result.FormTracking) {
                                    formTrackingDataLayer(result.FormTracking, true);
                                }
                                $(".membership-thankyou[data-response-type=true]").removeClass('inactive');
                            } else {
                                $(".membership-thankyou[data-response-type=false]").removeClass('inactive');
                            }
                        }

                        $formLoading.addClass('inactive');
                    }
                }).fail(function (error) {
                    // Failure
                    $(".membership-thankyou[data-response-type=false]").removeClass('inactive');
                    window.console && console.log('error', error);
                    $formLoading.addClass('inactive');
                });

                $('html,body').animate({ scrollTop: $(".membership").offset().top - 140 }, 1000);
            }
        });
    }
});

export default membershipObject;
